// Une page paginée est sa propre canonique (contenu distinct) ; filtres, vue et modale ne le sont pas.
export function useSeoCanonical() {
  const route = useRoute();

  const canonicalPath = computed(() => {
    const page = Number(firstQueryValue(route.query.page));
    return page > 1 ? `${route.path}?page=${page}` : route.path;
  });

  useHead({ link: [{ rel: "canonical", href: () => canonicalPath.value }] });
  useSeoMeta({ ogUrl: () => canonicalPath.value });
}
